import EndpointCard from '../EndpointCard';
import ParamTable from '../ParamTable';
import CodeBlock from '../CodeBlock';

export default function MerchantSection() {
  return (
    <>
      <div className="mb-8">
        <h2 className="font-serif text-bone-white text-2xl mb-2">Endpoints</h2>
        <div className="w-12 h-px bg-bone-white/20 mb-6" />
        <p className="font-mono text-[10px] text-bone-white/30 uppercase tracking-widest mb-4">System</p>
      </div>

      <EndpointCard
        id="health"
        method="GET"
        path="/api/health"
        description="Health check. No authentication required."
      />
      <CodeBlock
        language="json"
        code={`{
  "status": "ok",
  "service": "bonespay-api",
  "version": "1.0.0",
  "timestamp": "2026-03-18T12:00:00.000Z"
}`}
      />

      <div className="mt-12 mb-8">
        <p className="font-mono text-[10px] text-bone-white/30 uppercase tracking-widest">Merchants</p>
      </div>

      <EndpointCard
        id="register"
        method="POST"
        path="/api/merchants/register"
        description="Register a new merchant account. Returns an API key that is shown only once. Wallet addresses are screened against OFAC sanctions lists."
      />
      <ParamTable
        title="Request Body"
        params={[
          { field: 'email', type: 'string', required: true, description: 'Your email address' },
          { field: 'business_name', type: 'string', required: false, description: 'Your business or store name' },
          { field: 'default_wallet', type: 'string', required: true, description: 'Polygon wallet address (0x..., 42 chars) to receive USDC' },
          { field: 'webhook_url', type: 'string', required: false, description: 'Default URL for order completion callbacks' },
        ]}
      />
      <CodeBlock
        language="json"
        code={`{
  "email": "merchant@example.com",
  "business_name": "My Store",
  "default_wallet": "0x742d35Cc6634C0532925a3b844Bc9e7595f2bD18",
  "webhook_url": "https://mystore.com/wc-api/bonespay"
}`}
      />

      <p className="font-mono text-[10px] text-bone-white/30 uppercase tracking-wider mt-6 mb-2">Response 201</p>
      <CodeBlock
        language="json"
        code={`{
  "success": true,
  "id": "uuid",
  "email": "merchant@example.com",
  "business_name": "My Store",
  "api_key": "bp_live_abc123...",
  "webhook_secret": "whsec_xyz789...",
  "default_wallet": "0x742d35Cc6634C0532925a3b844Bc9e7595f2bD18",
  "created_at": "2026-03-18T12:00:00.000Z",
  "message": "Save your API key — it will not be shown again."
}`}
      />

      <ParamTable
        title="Errors"
        params={[
          { field: 'Email already registered', type: '409', description: 'Account exists for this email' },
          { field: 'Wallet address is restricted', type: '403', description: 'Wallet appears on OFAC sanctions list' },
        ]}
      />

      <EndpointCard
        id="merchant-profile"
        method="GET"
        path="/api/merchants/me"
        description="Retrieve your merchant profile."
        auth
      />
      <CodeBlock
        language="json"
        code={`{
  "id": "uuid",
  "email": "merchant@example.com",
  "business_name": "My Store",
  "default_wallet": "0x742d35Cc6634C0532925a3b844Bc9e7595f2bD18",
  "is_active": true,
  "branding": {},
  "settings": {
    "default_tolerance": 0.85,
    "preferred_providers": [],
    "webhook_url": "https://mystore.com/wc-api/bonespay"
  },
  "created_at": "2026-03-18T12:00:00.000Z"
}`}
      />
    </>
  );
}
